
import {Observable}              from 'rxjs';
import {filter, mapTo, pairwise} from 'rxjs/operators';

import PlaybackStatus from '../../Playback/Constants/PlaybackStatus';

const createPlaybackReadyStream = (
    playbackStatus$: Observable<PlaybackStatus>
): Observable<void> =>
    playbackStatus$
        .pipe(
            pairwise(),
            filter(([previousPlaybackStatus, nextPlaybackStatus]) => (
                [PlaybackStatus.A_LOADING, PlaybackStatus.B_LOADING].includes(previousPlaybackStatus) &&
                [PlaybackStatus.PLAYING, PlaybackStatus.PAUSED].includes(nextPlaybackStatus)
            )),
            mapTo(void 0)
        );

export default createPlaybackReadyStream;